import _objectSpread from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { MOST_NEGATIVE_SINGLE_FLOAT, MOST_POSITIVE_SINGLE_FLOAT } from '../constants';
import { getNativeContext } from '../helpers/get-native-context';
var DEFAULT_OPTIONS = {
  channelCount: 2,
  channelCountMode: 'max',
  channelInterpretation: 'speakers',
  gain: 1
};
export var createGainNodeConstructor = function createGainNodeConstructor(createAudioParam, createGainNodeRenderer, createNativeGainNode, isNativeOfflineAudioContext, noneAudioDestinationNodeConstructor) {
  return (
    /*#__PURE__*/
    function (_noneAudioDestination) {
      _inherits(GainNode, _noneAudioDestination);

      function GainNode(context) {
        var _this;

        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_OPTIONS;

        _classCallCheck(this, GainNode);

        var nativeContext = getNativeContext(context);

        var mergedOptions = _objectSpread({}, DEFAULT_OPTIONS, options);

        var nativeGainNode = createNativeGainNode(nativeContext, mergedOptions);
        var isOffline = isNativeOfflineAudioContext(nativeContext);
        var gainNodeRenderer = isOffline ? createGainNodeRenderer() : null;
        _this = _possibleConstructorReturn(this, _getPrototypeOf(GainNode).call(this, context, 'passive', nativeGainNode, gainNodeRenderer)); // Bug #74: Edge & Safari do not export the correct values for maxValue and minValue.

        _this._gain = createAudioParam(_assertThisInitialized(_this), isOffline, nativeGainNode.gain, MOST_POSITIVE_SINGLE_FLOAT, MOST_NEGATIVE_SINGLE_FLOAT);
        return _this;
      }

      _createClass(GainNode, [{
        key: "gain",
        get: function get() {
          return this._gain;
        }
      }]);

      return GainNode;
    }(noneAudioDestinationNodeConstructor)
  );
};